<template>
    <div id="fixed-help" class="fixed-help fixed-bottom-indented is-full" :class="{ active: isOpen }">
        <div class="fixed-help__inner chat-chat">
            <button
                @click="isOpen = !isOpen"
                type="button"
                id="switch-help"
                class="fixed-help__switch"
                aria-label="Zavřít nápovědu"
            >
                <div v-if="!isOpen" class="fixed-help__switch-icon fixed-help__switch-icon--inactive">
                    <SvgIcon :size="16" name="chat-thin" />
                </div>
                <div v-else class="fixed-help__switch-icon fixed-help__switch-icon--active">
                    <SvgIcon :size="16" name="chevron-right-thin" />
                </div>
            </button>
            <div class="fixed-help__container">
                <div class="fixed-help__content fixed-help__content--full">
                    <Button class="use-primary-dark" @click="useChat().show">
                        <SvgIcon :size="24" name="chat-thin" />
                        Zahájit chat
                    </Button>
                    <Button class="use-primary-dark" component="a" href="/centrum-podpory">
                        <SvgIcon :size="24" name="help-thin" />

                        Centrum podpory</Button
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import Button from "@/shared/components/atoms/Button.vue";
import { useChat } from "@/shared/composables/use-chat";

const isOpen = ref(false);
</script>
